/* eslint-disable max-len */
import moment from 'moment';

export default {
    localDate2Date: (localDate, twoDigit = false) => {
        const parsedDate = new Date(localDate?.year, localDate?.month, localDate?.day);

        // Do not change this as some of the places used prototype of Date from the returned parsedDate
        return twoDigit ? moment(parsedDate).format('MM/DD/YY') : parsedDate;
    },

    localDate2ISODateString: (localDate) => {
        if (!localDate) {
            return undefined;
        }
        const targetDate = new Date(localDate.year, localDate.month, localDate.day); 
        return new Date(targetDate.getTime() - (targetDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10); // Time is not included
    },

    stringDate2DateWithoutTimeZone: (isoDateString) => {
        return typeof isoDateString === 'string' ? isoDateString.substring(0, 10) : undefined;
    },

    date2LocalDate: (date) => {
        return date ? { year: date.getFullYear(), month: date.getMonth(), day: date.getDate() } : undefined;
    },

    compare: (thisDate, thatDate) => {
        if (!thisDate || !thatDate) return false;
        let result = thisDate.year - thatDate.year;
        if (result === 0) {
            result = thisDate.month - thatDate.month;
            if (result === 0) {
                result = thisDate.day - thatDate.day;
            }
        }
        return result;
    },

    parseLocalDateString2LocalDate: (localDateString, delimiter = '-') => {
        const splitDate = localDateString.split(delimiter);
        return {
            year: splitDate[0],
            month: splitDate[1],
            day: splitDate[2]
        };
    },

    differenceInDays: (startDate, endDate) => {
        const date1 = moment(startDate);
        const date2 = moment(endDate);

        return date1.diff(date2, 'days');
    },

    differenceInYears: (startDate, endDate) => {
        const date1 = moment(startDate);
        const date2 = moment(endDate);

        return date1.diff(date2, 'years');
    },

    /**
     * Convert the date from the server to local date with the assumption that server
     * date is passed in ISO8601 format with timezone set to GMT
     * @param {Object} serverDate date that comes from the server in Date format
     *
     * @returns {Object} LocalDate
     */
    serverDateToLocalDate: (serverDate) => {
        const date = moment(serverDate).local();
        return { year: date.year(), month: date.month(), day: date.date() };
    },

    isEqual: (localDate1, localDate2) => {
        return localDate1.year === localDate2.year
        && localDate1.month === localDate2.month
        && localDate1.day === localDate2.day;
    },

    inRange: (date, startDate, endDate) => {
        return date >= startDate && date <= endDate;
    },

    toLocalMidnight(dto) {
        return dto ? new Date(dto.year, dto.month, dto.day, 0, 1) : dto;
    }

};
